import initLogoAndTitle from "./initLogoAndTitle.js";
import {
  initContactInfoDiv,
  initOpeningHoursDiv,
} from "./initInfoDivFromData.js";

export default function initFooter(contentDiv) {
  const footer = document.createElement("footer");
  footer.classList.add("main-footer");

  const footerContent = document.createElement("div");
  footerContent.classList.add("footer-content");
  footer.appendChild(footerContent);

  // Append the logo and the title
  footerContent.appendChild(initLogoAndTitle(contentDiv));

  // Add contact info div
  footerContent.appendChild(initContactInfoDiv());

  // Add opening hours info div
  footerContent.appendChild(initOpeningHoursDiv(true));

  // Add image credit
  footer.appendChild(initImageCredit());

  return footer;
}

function initImageCredit() {
  const imgCreditDiv = document.createElement("div");
  imgCreditDiv.classList.add("img-credit");

  imgCreditDiv.innerHTML = `Logo from 
    ${getAnchorStr("SVGrepo", "https://www.svgrepo.com/")}.
    Photos from 
    ${getAnchorStr("Unsplash", "https://unsplash.com/")},  
    ${getAnchorStr("Pixabay", "https://pixabay.com/")}, 
    ${getAnchorStr("FreePik", "https://www.freepik.com/")}, and
    ${getAnchorStr("Pexels", "https://www.pexels.com/")}.
    See ${getAnchorStr(
      "README.txt",
      "https://github.com/frarosset/restaurant-page/blob/main/src/img/README.txt"
    )} for more details.
    The images in the Contact tab have been generated by AI using
    ${getAnchorStr(
      "Microsoft Image Creator",
      "https://www.bing.com/images/create"
    )}.
    The images have also been resized with
    ${getAnchorStr("ImageResizer", "https://imageresizer.com/")}
    and compressed with 
    ${getAnchorStr("TinyPNG", "https://tinypng.com/")}.`;

  return imgCreditDiv;
}

function getAnchorStr(label, link) {
  return `<a href="${link}" target="_blank">${label}</a>`;
}
